__turbopack_context__.v({
  "bottomContainer": "style-module-scss-module__66DBhG__bottomContainer",
  "clutchInfo": "style-module-scss-module__66DBhG__clutchInfo",
  "clutchLink": "style-module-scss-module__66DBhG__clutchLink",
  "clutchReviewsLabel": "style-module-scss-module__66DBhG__clutchReviewsLabel",
  "clutchWrapper": "style-module-scss-module__66DBhG__clutchWrapper",
  "fadeIn": "style-module-scss-module__66DBhG__fadeIn",
  "flashBg": "style-module-scss-module__66DBhG__flashBg",
  "gradientLayer": "style-module-scss-module__66DBhG__gradientLayer",
  "graffitiBg": "style-module-scss-module__66DBhG__graffitiBg",
  "headerWrapper": "style-module-scss-module__66DBhG__headerWrapper",
  "lottieContainer": "style-module-scss-module__66DBhG__lottieContainer",
  "parallax": "style-module-scss-module__66DBhG__parallax",
  "parallaxContainer": "style-module-scss-module__66DBhG__parallaxContainer",
  "sliderTitle": "style-module-scss-module__66DBhG__sliderTitle",
  "sliderWrapper": "style-module-scss-module__66DBhG__sliderWrapper",
  "verticalDivider": "style-module-scss-module__66DBhG__verticalDivider",
  "videoChubClickHandler": "style-module-scss-module__66DBhG__videoChubClickHandler",
  "videoContainer": "style-module-scss-module__66DBhG__videoContainer",
  "videoWrapper": "style-module-scss-module__66DBhG__videoWrapper",
  "wrapper": "style-module-scss-module__66DBhG__wrapper",
});
